import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../../App";
import { PageContext } from "../../pages/job-details";
import { Stack, Link, useTheme } from "@mui/material";
import { config } from "../../config";
import { useTranslate } from "../../locales/use-locales";
import LanguageSelector from "./language-selector";

function Header({ company }) {
  const theme = useTheme(); // Import the theme for breakpoints
  const { darkMode, setDarkMode } = useContext(AppContext);
  const { jobData } = useContext(PageContext);
  const { t } = useTranslate();

  const [isVisible, setIsVisible] = useState(true); // Tracks header visibility
  const [lastScrollY, setLastScrollY] = useState(0); // Tracks the last scroll position

  // Handle scrolling to toggle header visibility
  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY && currentScrollY > 50) {
      // Scroll down and past 50px
      setIsVisible(false);
    } else {
      // Scroll up
      setIsVisible(true);
    }
    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  return (
    <Stack
      className="header contained"
      sx={{
        position: "fixed",
        top: isVisible ? "15px" : "-100px", // Slide up or down
        backgroundColor: "white",
        left: "50%",
        borderRadius: "10px",
        transform: "translateX(-50%)",
        zIndex: "99999",
        px: { xs: 2, md: 3 },
        border: "1px solid lightgray",
        transition: "top 0.3s ease-in-out", // Smooth sliding effect
      }}
    >
      <Stack
        fullWidth
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        sx={{
          height: { xs: "50px", sm: "60px", md: "75px" }, // Responsive heights
          background: "rgba(255, 255, 255, 0.2)",
          backdropFilter: "blur(10px)",
          borderRadius: "10px",
        }}
      >
        {company?.companyLogo && company?.companyLogo !== "" && (
          <Stack
            className="left"
            sx={{
              height: "100%",
              padding: "5px",
            }}
          >
            <a
              href="/"
              style={{ height: "100%", maxWidth: "140px", display: "block" }}
            >
              <img className="logo" src={company?.companyLogo} alt="Logo" />
            </a>
          </Stack>
        )}

        <Stack
          className="middle"
          height="100%"
          direction="row"
          justifyContent="center"
        ></Stack>

        <Stack
          className="right"
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="flex-end"
        >
          <Link
            href="/"
            sx={{
              textDecoration: "none",
              color: "black",
              transition: "500ms color",
              cursor: "pointer",
              "&:hover": {
                color: config.colors.secondary,
              },
            }}
          >
            {t("header.careers")}
          </Link>
          <LanguageSelector />
        </Stack>
      </Stack>
    </Stack>
  );
}

export default Header;
